// function to capitalize the first letter of each word and first letter of each word after /
export const capitalizeWords = (string = '') => {
  return string
    .split('/')
    .map((segment) => segment.charAt(0).toUpperCase() + segment.slice(1))
    .join('/');
};

export const capitalizeEveryWord = (string = '') => {
  // Define words to exclude from capitalization
  const excludeWords = ['und'];

  return string
    .split('/')
    .map((segment) =>
      segment
        .split(' ')
        .map((word) =>
          excludeWords.includes(word.toLowerCase())
            ? word
            : word.charAt(0).toUpperCase() + word.slice(1),
        )
        .join(' '),
    )
    .join('/');
};
